import { Tabs } from "@newsela/angelou";

import { IStandard } from "@/search/Langston/types/IStandard";
import TeacherToolsContent from "../TeacherToolsContent";
import { newTagCss, tabListStyle } from "./TeacherToolsTabs.style";

interface TeacherToolsTabsProps {
  canViewLessonPlanner: boolean;
  selectedStandards: IStandard[];
  setIsStandardsModalActive: (active: boolean) => void;
  setSelectedStandards: React.Dispatch<React.SetStateAction<IStandard[]>>;
}

const DEFAULT_TAB = "main-idea";

const TeacherToolsTabs = ({
  canViewLessonPlanner,
  selectedStandards,
  setIsStandardsModalActive,
  setSelectedStandards,
}: TeacherToolsTabsProps) => {
  const tabItems = [
    ...(canViewLessonPlanner
      ? [
          {
            panelId: "lesson-planner",
            name: "Lesson planner",
            isNew: true,
          },
        ]
      : []),
    {
      panelId: "main-idea",
      name: "Main idea",
    },
    {
      panelId: "key-terms",
      name: "Key terms",
    },
    {
      panelId: "before-reading-activity",
      name: "Before reading activity",
    },
    {
      panelId: "discussion-questions",
      name: "Discussion questions",
    },
  ];

  const initialPanelId = tabItems[0]?.panelId || DEFAULT_TAB;

  return (
    <Tabs
      __cssFor={{ tabList: tabListStyle }}
      dataProps={{ "data-qa-selector": "teacher_tools_tabs" }}
      flavor="underlined"
      horizontalSwitch="xs"
      initialPanelId={initialPanelId}
      panels={tabItems.map(({ panelId, name, isNew }) => ({
        panelId,
        name,
        SvgComponent: () => (isNew ? <span css={newTagCss}>New</span> : null),
        panelContent: (
          <TeacherToolsContent
            selectedStandards={selectedStandards}
            selectedTool={panelId}
            setIsStandardsModalActive={setIsStandardsModalActive}
            setSelectedStandards={setSelectedStandards}
          />
        ),
      }))}
    />
  );
};

export default TeacherToolsTabs;
